import React, { useContext, useEffect } from "react";
import { Link as linkIcon } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
  Button,
  Icon,
} from "@material-ui/core";

// Contexts
import UserContext from "../../context/users/UserContext";
import ParameterContext from "../../context/parameters/ParameterContext";

// Components
import UserSearch from "./UserSearch";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  field: {
    fontSize: "14px",
  },
}));

const UserHome = () => {
  const classes = useStyles();

  const { getUsers } = useContext(UserContext);
  const { user_group, getUserGroup } = useContext(ParameterContext);

  useEffect(() => {
    getUsers();
    getUserGroup();
  }, []);

  return (
    <div>
      <Grid container spacing={1}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> User </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit"> User </Link>{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  component={linkIcon}
                  style={{
                    color: "white",
                  }}
                  to="/user/create"
                  startIcon={
                    <Icon
                      className="fa fa-plus-circle"
                      style={{
                        fontSize: 20,
                      }}
                    />
                  }
                >
                  <span> Create User </span>{" "}
                </Button>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Paper>{" "}
        </Grid>
        <Grid item xs={12}>
          {" "}
          {user_group && <UserSearch classes={classes} />}{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default UserHome;
